import { createSelector } from 'reselect';
import find from 'ramda/es/find';


const createProductInCartSelector = () => createSelector(
  [
    state => state.shop.cart.cartItems,
    (_, { id }) => id,
  ],
  (cartItems, id) => find(({ variantId }) => (variantId === id), cartItems) || {},
);

export default createProductInCartSelector;
